<h1 class="text-success mb-4">Commande de crédits</h1>

<app-informations-commande-messages
  *ngIf="!isNotaire"
  [isRenouvellementMessageVisible]="!isRenouvellement"
></app-informations-commande-messages>

<div class="d-flex justify-content-end mt-4">
  <p-button
    *ngIf="isNotaire"
    id="commander-en-ligne"
    level="primary"
    label="Commander en ligne"
    routerLink="/commander-credits-en-ligne"
  ></p-button>
</div>

<app-grille-achat-services [tarifs]="tarifs"></app-grille-achat-services>
